import React from "react"
import { IClientRequestDto } from "../../../types/request/IClientRequestDto"
import { getMskTime, round2Digits, spacedNum } from "../../common/CommonHelper"
import { RequestStatus } from "../../../types/request/RequestStatus"
import { IRequestStatus } from "../../../types/request/IRequestStatus"
import { IPageResponse } from "../../../types/IPageResponse"
import { ICheckConversationResponse } from "../../../types/messenger/ICheckConversationResponse"

export const ManagerRequestListItem: React.FC<{
  request: IClientRequestDto
  action?: (id: number) => void
  showMessenger: (iid: string | undefined, uid: number | undefined) => void
  unreadList: IPageResponse<ICheckConversationResponse> | undefined
  isCurrencyVariant: boolean
}> = ({ request, action, showMessenger, unreadList, isCurrencyVariant }) => {
  const getRequestStatusClass = () => {
    switch (request.status) {
      case "NEW":
        return "global-item"
      case "REJECTED":
        return "global-item-error"
      case "APPROVED":
        return "global-item"
      case "USED":
        return "global-item-done"
      default:
        return "global-item"
    }
  }

  const getUnreadCounter = (instanceId: string | undefined): number => {
    let counter = 0
    if (!instanceId) return counter
    let unreadItem = unreadList?.items.filter(item => item.instanceId === instanceId)[0]
    counter = unreadItem ? unreadItem.num : 0
    return counter
  }

  return (
    <li className={getRequestStatusClass()}>
      <div className="global-scroll-block" onClick={() => (action && request.id ? action(request.id) : void 0)}>
        <p className="global-item-text width-130">
          <span>№{request.id}</span>
          <span
            dangerouslySetInnerHTML={{
              __html: getMskTime(request.createdAt || "") || ""
            }}
          />
        </p>
        <p className="global-item-text globak-num width-100">
          {spacedNum(round2Digits(Number(request.invoicePrice) / 100) || 0)}
        </p>
        <p className="global-item-text width-70">{request.currency}</p>
        <p className="global-item-text global-bank cols-request">
          {isCurrencyVariant
            ? request.company?.countryRef?.name?.toUpperCase() || "-"
            : request.recipientCountry?.name?.toUpperCase() || "-"}
        </p>
        <p className="global-item-text global-bank cols-request">
          {isCurrencyVariant
            ? request.currencyPayerBankCountry?.name?.toUpperCase() || "-"
            : request.recipientBankCountry?.name?.toUpperCase() || "-"}
        </p>
        <p className="global-item-text globak-num cols-request">
          {isCurrencyVariant ? (
            <>{request.currencyPayerName}</>
          ) : (
            <>
              <span>{request.userProfile?.name}</span>
              <span className="deal-name">{request.clientCompanyName || "-"}</span>
            </>
          )}
        </p>
        {!isCurrencyVariant && <p className="global-item-text globak-swift cols-request">{request.inn}</p>}

        <p className="global-item-text width-130">{RequestStatus[request.status as keyof IRequestStatus]}</p>
      </div>
      <button className="chat-deals" onClick={() => showMessenger(request.id?.toString(), request.user?.userId)}>
        {getUnreadCounter(request.id?.toString()) > 0 ? (
          <span className="message-new">{getUnreadCounter(request.id?.toString())}</span>
        ) : (
          ""
        )}
      </button>
    </li>
  )
}
